import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  // 首页
  {
    path: "/index",
    component: () => import("@/views/index"),
    meta: {
      title: "index",
      keepAlive: true,
    },
  },
  // proudct 页
  {
    path: "/products",
    component: () => import("@/views/products"),
    meta: {
      title: "product",
      keepAlive: true,
    },
  },
  // support 页
  {
    path: "/support",
    component: () => import("@/views/support"),
    meta: {
      title: "support",
      keepAlive: true,
    },
  },
  // 商详页
  {
    path: "/product-detail",
    component: () => import("@/views/productDetail"),
    meta: {
      title: "product-detail",
      keepAlive: true,
    },
  },
  // about us 页
  {
    path: "/company-info",
    component: () => import("@/views/companyInfo"),
    meta: {
      title: "company-info",
      keepAlive: true,
    },
  },
  {
    path: "/",
    redirect: "/index",
    meta: {
      title: "index",
    },
  },
];
const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: "history",
  base: "/",
  routes,
});

export default router;
